import React from "react";
import { DefaultLayout } from "../layouts";
import { SingleBlogScreen } from "../components";
import { Navigate, useParams } from "react-router-dom";

export default function SingleBlogPage() {
  const params = useParams();
  const reqPermalink: string | undefined = params.permalink;
  if (reqPermalink === undefined) {
    return <Navigate to="/" />
  }
  return (
    <DefaultLayout>
      <SingleBlogScreen id={reqPermalink!} />
    </DefaultLayout>
  );
}
